(function () {
  'use strict';

  var INTERVAL = 2200;

  class YgCycleText extends HTMLElement {
    connectedCallback() {
      this.words = Array.prototype.slice.call(this.children);
      if (this.words.length < 2) return;

      var maxWidth = 0;
      for (var i = 0; i < this.words.length; i++) {
        maxWidth = Math.max(maxWidth, this.words[i].getBoundingClientRect().width);
      }
      this.style.width = maxWidth + 'px';

      this.index = 0;
      this.words[0].classList.add('is-active');
      this.timer = window.setInterval(this.next.bind(this), INTERVAL);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    next() {
      this.words[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.words.length;
      this.words[this.index].classList.add('is-active');
    }
  }

  if (!customElements.get('yg-cycle-text')) {
    customElements.define('yg-cycle-text', YgCycleText);
  }
})();
